import { localStorage } from 'dibs-browser-storage';
import {
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';

import {
    SUSPECTED_TRADE_ACQUISITION_VIEWS,
    SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS,
    SUSPECTED_TRADE_ACQUISITION_DISMISSED,
} from './constants';

function getViewCount() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_VIEWS) || 0;
}

export function logView() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_VIEWS, getViewCount() + 1);
}

function maxViewsCountExceeded() {
    return getViewCount() >= SUSPECTED_TRADE_ACQUISITION_MAX_VIEWS;
}

export function showSuspectedTradeUserAcquisition() {
    return !maxViewsCountExceeded();
}

export function setAcquisitionDismissed() {
    localStorage.setItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED, true);
}

export function isAcquisitionDismissed() {
    return localStorage.getItem(SUSPECTED_TRADE_ACQUISITION_DISMISSED);
}

const SUSPECTED_TRADE_CONSUMERS_TEST_NAME = 'SUSPECTED_TRADE_CONSUMERS';

export function showSuspectedTradeTest() {
    return isAbTestVariant(document.cookie, SUSPECTED_TRADE_CONSUMERS_TEST_NAME);
}

export function trackSuspectedTradeTest(pageType) {
    const trackingData = getAbTestTrackingData(
        document.cookie,
        SUSPECTED_TRADE_CONSUMERS_TEST_NAME
    );
    tracking.trackAbTestEvent(trackingData, pageType);
}
